import React from "react";
import ContentListGrid from "../components/ContentListGrid";
import PublicPageSettings from "../components/PublicPageSettings";
import { COLLECTIONS } from "../utils/cmsSchema";

export default function InsightsList() {
  return (
    <div>
      <PublicPageSettings
        collectionKey="insights"
        publicPath="/market-insights"
        defaultHeading="Property Market Insights."
        defaultSubheading="Make informed real estate decisions in the Philippines. Our comprehensive research and analysis provide the clarity you need."
      />
      <ContentListGrid
        schema={COLLECTIONS.insights}
        title="Market Insights"
        subtitle="Reports, studies, and downloadables shown on /market-insights."
        newRoute="/cms/insights/new"
        metaFor={(d) => (d.pdf ? "PDF attached" : "No PDF")}
      />
    </div>
  );
}
